import { Fragment, useId, useRef } from "react";
import { SHORTCUTS } from "../shortcuts";
import { useFocusTrap } from "../useFocusTrap";

// Modal listing the keyboard shortcuts. Opened by "?" (Dashboard's global
// keydown handler) or from the settings popover; closes on Escape, the Close
// button, and returns focus to the opener (useFocusTrap).
export const ShortcutsHelp = ({ onClose }: { onClose: () => void }) => {
  const titleId = useId();
  const dialogRef = useRef<HTMLDivElement>(null);
  useFocusTrap(dialogRef, true, onClose);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-safe-modal">
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        className="max-h-[80vh] w-full max-w-md overflow-y-auto rounded bg-white p-4 text-sm shadow outline-none"
      >
        <h2 id={titleId} className="font-semibold">
          Keyboard shortcuts
        </h2>
        <dl className="mt-3 grid grid-cols-[auto_1fr] items-baseline gap-x-4 gap-y-2">
          {SHORTCUTS.map((s) => (
            <Fragment key={s.description}>
              <dt className="whitespace-nowrap">
                {s.keys.map((k, i) => (
                  <Fragment key={k}>
                    {i > 0 && <span className="text-neutral-400"> / </span>}
                    <kbd className="rounded border border-neutral-300 bg-neutral-50 px-1.5 py-0.5 font-mono text-xs">
                      {k}
                    </kbd>
                  </Fragment>
                ))}
              </dt>
              <dd className="text-neutral-700">{s.description}</dd>
            </Fragment>
          ))}
        </dl>
        <div className="mt-3 flex justify-end">
          <button onClick={onClose} className="min-h-10 sm:min-h-0 rounded border px-3 py-1 sm:px-2">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
